<template>
  <div class="ly-table">
    <div class="ly-sort ly-sort-his">
      <div class="sort-count">
        <p class="table-cell-all">
          {{ $t("messages.all") }} <span class="table-cell-count">{{ pageInfo.totalListSize }}</span
          >{{ $t("messages.unit") }}
        </p>
        <div class="sort-select">
          <el-select
            size="medium"
            v-model="count"
            :placeholder="$t('messages.plCount25')"
            @change="changeCount"
          >
            <el-option
              v-for="item in countList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <span>
            {{ $t("messages.perShow") }}
          </span>
        </div>
      </div>
      <div v-if="!$isMobile()">
        <span class="count">
          <el-checkbox 
            v-if="userInfo.indvInfoRetvAutYn == 'Y'"
            v-model="masking" 
            true-label="false" 
            false-label="true" 
            :label="$t('messages.lblUnmasking')"
          />
        </span>
        <el-button size="small" type="primary" @click="goRegist">{{
          $t("messages.titEquipTkotTkinApy")
        }}</el-button>
        <el-button plain size="small" type="excel" @click="downloadExcel"
          :disabled="tableData.length == 0"
          >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
        ></el-button>
      </div>
    </div>
    <div v-if="$isMobile()" class="btn-m-top">
      <el-button size="large" type="primary" @click="goRegist">{{
        $t("messages.btnImportApy")
      }}</el-button>
    </div>
    <div class="table-body">
      <idc-list :tableHeader="tableHeader" :tableData="tableData" 
        @clickRow="clickRow"
      >
        <template #tkinTkotDiv="{ scope }">
          {{ scope.row.tkinTkotDiv == 'IN' ?  $t("messages.lblImport") : scope.row.tkinTkotDiv == 'OUT' ?  $t("messages.lblExport") : ""}}
        </template>
      </idc-list>
      <idc-pagenation :pageInfo.sync="pageInfo" @movePage="getOprEquipTkinApyList" layout="prev, pager, next " ></idc-pagenation>
    </div>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";
import IdcPagenation from "@/components/common/IdcPagenation";
import { getNow, commonExcelDownload, copyObject } from "@/assets/js/common.js";

export default {
  components: {
    IdcList,
    IdcPagenation,
  },
  mounted() {
    if (this.$isMobile()) {
      /*
      for (let i = 0; i < 10; i++) {
        this.tableData.push({
          col1: "SR00001",
          col2: "목동1",
          col3: "2022/01/19",
          col4: "홍길동",
          col5: "엔투앰",
          col6: "3EA",
          state: ["요청"],
        });
      }
      */
      this.$store.dispatch("userInfoStore/getCustLoginCustInfo").then(data => {
          this.custId = data.custId;

          let myIdc = this.$BIZ_SERVICE.post(this.$API_URLS.Com.getMySvcIdcCdList, {});
          myIdc.then((res) => { 
            if(res) {
              let arr = [];
              res.data.resData.map((data) => { arr.push(data.idcCd); });
              this.myIdcAllLst = arr;
              console.log(this.myIdcAllLst)
            }
            this.getOprEquipTkinApyList(1);
          })
          .catch((error) => {
            console.log(error);
          });
          
      })
      .catch((error) => {
        alert(error)    
      });
    } else {
      this.$store.dispatch("userInfoStore/getCustLoginCustInfo").then(data => {
          this.custId = data.custId;

          let myIdc = this.$BIZ_SERVICE.post(this.$API_URLS.Com.getMySvcIdcCdList, {});
          myIdc.then((res) => { 
            if(res) {
              let arr = [];
              res.data.resData.map((data) => { arr.push(data.idcCd); });
              this.myIdcAllLst = arr;
              console.log(this.myIdcAllLst)
            }
            this.getOprEquipTkinApyList(1);
          })
          .catch((error) => {
            console.log(error);
          });
          
      })
      .catch((error) => {
        alert(error)    
      });
      this.getUserInfoPopupData();
    }
    /*
    if (this.$isMobile()) {
      this.tableHeader = [
        {
          prop: "col1",
          label: "요청번호",
        },
        {
          prop: "col2",
          label: "IDC",
        },
        {
          prop: "col3",
          label: "반입예정일",
        },
        {
          prop: "col4",
          label: "방문자",
        },
        {
          prop: "col5",
          label: "소속사",
        },
        {
          prop: "col6",
          label: "반입장비수",
        },
        {
          prop: "state",
          label: "상태",
        },
      ];
    }
    */
   if(this.$route.query.action === 'open') {
      this.goRegist();
    }
  },
  watch: {
    masking() {
      this.changeMask(this.pageInfo.curPage);
      if(this.masking == 'false') {
        this.putMaskingHstData()
      }         
    },
  },
  computed: {
    getCustHnglNm() {
      return this.$store.getters["userInfoStore/getCustHnglNm"];
    },     
    tableHeader() {
      return [
        /*
        {
          prop: "rn",
          label: "NO",
          // type: "index",
          width: "5",
        },
        */
        {
          prop: "tkinTkotDiv",
          label: this.$t("messages.lblEquipment"),
          width: 100,
          columnType : "custom"
        },
        {
          prop: "equipTkinApyId",
          //label: "신청No.",
          label: this.$t("messages.lblRegisterNo"),
          width: 200,
        },
        {
          prop: "tkinIdcCdNm",
          label: "DC",
          width: 100,
        },
        {
          prop: "tkinFlrNm",
          //label: "층",
          label: this.$t("messages.lblFloor"),
          width: 100,
        },
        {
          prop: "tkinRoomNm",
          //label: "룸",
          label: this.$t("messages.lblRoom"),
          width: 120,
        },
        {
          prop: "tkinWhyNm",
          //label: "반입사유",
          label: this.$t("messages.lblReason"),
          width: 100,
        },
        {
          prop: "equipTypeCdNm",
          //label: "장비유형",
          label: this.$t("messages.lblDeviceClassificate"),
          width: 100,
        },
        {
          prop: "vendrNm",
          //label: "벤더",
          label: this.$t("messages.lblVender"),
          width: 100,
        },
        {
          prop: "prodnm",
          //label: "품명(모델명)",
          label: this.$t("messages.lblProductNameModelName"),
          width: 100,
        },
        // {
        //   prop: "srialNo",
        //   label: "S/N",
        //   width: "10",
        // },
        {
          prop: "qnty",
          //lable: 수량
          label: this.$t("messages.lblQauntity"),
          width: 100,
        },
         {
          prop: "rmark",
          //lable: 비고
          label: this.$t("messages.lblRemarks"),
          width: 140,
        },
        {
          prop: "tkinrNm",
          //label: "반입자명",
          label: this.$t("messages.lblImporterExporter"),
          width: 100,
        },
        {
          prop: "tkinPamDt",
          //label: "반입예정일시",
          label: this.$t("messages.lblImportExportDate"),
          width: 130,
        },
        {
          prop: "regDt",
          //label: "신청일시",
          label: this.$t("messages.lblRequestDate"),
          width: 200,
        },
        {
          prop: "tkinSttusCdNm",
          //label: "상태",
          label: this.$t("messages.condition"),
          width: 100,
        },
        // {
        //   prop: "tkotApySttusCdNm",
        //   label: "반출상태",
        //   width: "7",
        // },
      ];
    }
  },
  data() {
    return {
      tableData: [],
      count: 25,
      countList: [
        {
          value: 25,
          label: "25개",
        },
        {
          value: 50,
          label: "50개",
        },
      ],
      pageInfo:{
        curPage:1,
        startIndex :0,
        lastIndex :10,
        pageListSize: 10,
        totalListSize:0,
      },

      searchForm:{
        tkinIdcCd:"",
        tkinSttusCd:"",
        tkinrNm:"",
        tkinPamDt:"",
        apyDivCd:"2030", //신청구분코드(예약:2030,현장:2029)
      },

      masking: "true",
      // masking: "false",

      myIdcAllLst: [], //idc all lst string in절(,)
      userInfo : {}
    };
  },
  methods: {
 putMaskingHstData(){
       let reqData = {
          type: "masking",
          whySbst: "고객사정보 확인",
          screenPath: "고객포탈>HelpDesk>장비반출입신청>장비반출입신청",
          divison: "다건",
          checkData: this.getCustHnglNm,
        }

        this.$BIZ_SERVICE
        .post(this.$API_URLS.Com.postFileDownloadHst, reqData)
        .then((res) => {

        })
        .catch((error) => {})
        .finally(() => {});
    }    ,      
    async getUserInfoPopupData() {
      const { data } = await this.$BIZ_SERVICE.post(
        this.$API_URLS.Com.getUserInfoPopupData,
        {masking: false}
      );
      this.userInfo = data.resData;
    },
    downloadExcel() {
      let searchData = {};
      let targetHeader;
      let targetTitle;
      let targetSeviceName;
    
      targetHeader = copyObject(this.tableHeader);

      for(let i=0;i<targetHeader.length;i++) {
        targetHeader[i].width = Number(targetHeader[i].width)*10;
      }

      targetTitle = "장비반출입목록_";
      targetSeviceName = "equipIOList3";
      
      searchData = {custId:this.custId
                   , tkinIdcCd: this.searchForm.vistIdcCd
                   , tkinrNm: this.searchForm.vistrNm
                   //, tkinPamDt: this.searchForm.virsDt
                   , fromDate : this.searchForm.fromDate
                   , toDate : this.searchForm.toDate
                   , tkinSttusCd: this.searchForm.rsrvSttusCd
                   , masking : (this.masking == "true" ? true : false)
                   , myIdcAllLst : this.myIdcAllLst
                  };

      commonExcelDownload(this.$BIZ_SERVICE
      , this.$API_URLS.Opr.excelDownloadByInotAdm
      , targetTitle + getNow() + ".xlsx", targetSeviceName
      , [
          {
            prop: "tkinTkotDivHnglNm",
            label: this.$t("messages.lblEquipment"),
            width: "100"
          },
          {
            prop: "equipTkinApyId",
            label: this.$t("messages.lblRegisterNo"),
            width: "100"
          },
          {
            prop: "tkinIdcCdNm",
            label: "DC",
            width: "100",
          },
          {
            prop: "tkinFlrNm",
            label: this.$t("messages.lblFloor"),
            width: "100"
          },
          {
            prop: "tkinRoomNm",
            label: this.$t("messages.lblRoom"),
            width: "100"
          },
          {
            prop: "tkinWhyNm",
            label: this.$t("messages.lblReason"),
            width: "100",
          },
          {
            prop: "equipTypeCdNm",
            label: this.$t("messages.lblDeviceClassificate"),
            width: "100",
          },
          {
            prop: "vendrNm",
            label: this.$t("messages.lblVender"),
            width: "100",
          },
          {
            prop: "prodnm",
            label: this.$t("messages.lblProductNameModelName"),
            width: "100"
          },
          {
            prop: "qnty",
            label: this.$t("messages.lblQauntity"),
            width: "100"
          },
          {
            prop: "rmark",
            label: this.$t("messages.lblRemarks"),
            width: "150"
          },
          {
            prop: "cmpnNm",
            label: this.$t("messages.lblAgency"),
            width: "100"
          },
          {
            prop: "tkinrNm",
            label: this.$t("messages.lblImporterExporter"),
            width: "100"
          },
          {
            prop: "tkinPamDt",
            label: this.$t("messages.lblImportExportDate"),
            width: "100"
          },
          {
            prop: "regDt",
            label: this.$t("messages.lblRequestDate"),
            width: "100"
          },
          {
            prop: "tkinApySttusCdNm",
            label: this.$t("messages.condition"),
            width: "100"
          },
        ]
      , searchData
      );
    },
    clickRow(col,row) {
      this.$emit("goDetail", row);
    },
    changeCount(val){
      this.count = val;
      this.tableData = [];
      this.getOprEquipTkinApyList(1);
    },
    changeMask(val) {
      this.tableData = [];
      this.getOprEquipTkinApyList(val);
    },
    goRegist() {
      if(this.$isMobile()) {
        location.href = "/helpDesk/equipTkotTkinApyDetailMobile";
      } else {
        let url = this.$router.resolve("/helpDesk/equipTkotTkinApyDetail").href;
        window.open(url, "_blank", "width=1300,height=800,noopener, noreferrer");
      }
    },
    getOprEquipTkinApyList(curPage) {
      const reqData = {};
      reqData.curPage = curPage;
      reqData.pageListSize = this.count;
      reqData.isPaging = true;

      reqData.custId = this.$store.getters["userInfoStore/getCustId"]; //고객id회사만조회
      
      reqData.tkinIdcCd = this.searchForm.vistIdcCd;
      reqData.tkinrNm = this.searchForm.vistrNm;
      //reqData.tkinPamDt = this.searchForm.virsDt;
      reqData.tkinSttusCd = this.searchForm.rsrvSttusCd;
      reqData.fromDate = this.searchForm.fromDate;
      reqData.toDate = this.searchForm.toDate;

      //마스킹추가
      reqData.masking = (this.masking == "true" ? true : false);

      //전체idc리스트추가
      reqData.myIdcAllLst = this.myIdcAllLst;

      this.$BIZ_SERVICE
        //.post(this.$API_URLS.Opr.getOprEquipTkinApyList , reqData)
        .post(this.$API_URLS.Opr.getOprEquipTkinApyCustList , reqData)
        .then((res) => {
          const resData = JSON.parse(res.data.resData);
          this.tableData = resData.list;
          this.pageInfo = resData.page;
        })
        .catch((error) => {
            console.log(error)
        }).finally(()=>{
        });
    },
  },
  created() {
    this.custId = this.$store.getters["userInfoStore/getCustId"]; //고객id회사만조회
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-checkbox__label {
      vertical-align: middle;
      padding-left: 8px;
      font-size: 1rem;
      margin-right:10px;
  }
}
</style>
